import state from '@/vuex/vinculos-documento/state.js'
import getters from '@/vuex/vinculos-documento/getters.js'
import mutations from '@/vuex/vinculos-documento/mutations.js'
import actions from '@/vuex/vinculos-documento/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
